/**
 * BIC Quality API
 * Quality Services API - Use this API to access the Quality Services of the Building Information Cloud (BIC).
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ParameterEnums } from './parameterEnums';

export interface Parameter { 
    id?: number;
    name?: string;
    value?: string;
    type?: Parameter.TypeEnum;
    enums?: Array<ParameterEnums>;
}
export namespace Parameter {
    export type TypeEnum = 'ENUM' | 'INT' | 'BOOL' | 'FLOAT';
    export const TypeEnum = {
        ENUM: 'ENUM' as TypeEnum,
        INT: 'INT' as TypeEnum,
        BOOL: 'BOOL' as TypeEnum,
        FLOAT: 'FLOAT' as TypeEnum
    };
}